import useFetchJobPostImportRequest from '../../../api/useFetchJobPostImportRequest';
import NotFoundPage from '../../../../errors/NotFoundPage';
import { useNavigate } from '@tanstack/react-router';
import Loading from '@/components/Loading';
import { JobPostImportRequestsProcessingTemplate } from './show/JobPostImportRequestsProcessingTemplate';
import { JobPostImportRequestsMappingTemplate } from './show/JobPostImportRequestsMappingTemplate';
import { JobPostImportRequestsFailedTemplate } from './show/JobPostImportRequestsFailedTemplate';
import { MainContents } from '@/components/MainContents';
import { useSetBreadcrumbTitle } from '@/hooks/useBreadcrumb';

type Props = {
  encryptId?: string;
};

export function JobPostImportRequestsShowTemplate({ encryptId }: Props) {
  const { data, isLoading, isError } = useFetchJobPostImportRequest(encryptId, {
    pollWhileStatusIn: ['draft', 'processing'],
  });
  const navigate = useNavigate();

  useSetBreadcrumbTitle('CSVから取り込み');

  if (!encryptId || isError) {
    return <NotFoundPage />;
  }

  if (isLoading || !data || data.status === 'draft') {
    return (
      <div className="flex h-full flex-col items-center justify-center p-6">
        <Loading size="small" />
      </div>
    );
  }

  if (data.status === 'completed') {
    navigate({
      to: '/agent/provided_job_posts',
    });
    return null;
  }

  return (
    <MainContents>
      <div className="grid grid-cols-1 gap-6">
        <section className="rounded-md bg-white p-6 shadow-xs">
          {data.status === 'processing' && (
            <JobPostImportRequestsProcessingTemplate importRequest={data} />
          )}
          {data.status === 'failed' && <JobPostImportRequestsFailedTemplate importRequest={data} />}
          {data.status === 'ready' && <JobPostImportRequestsMappingTemplate importRequest={data} />}
        </section>
      </div>
    </MainContents>
  );
}
